export function updateTickmarks(tickmarksEl: HTMLElement, selected: string): void
{
	tickmarksEl.querySelectorAll('span').forEach(el => {
		el.innerText === selected
			? el.classList.add('active')
			: el.classList.remove('active');
	});
}
